import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import UniversityAnalysisModal from './UniversityAnalysisModal';
import { useAuth } from '../../../contexts/AuthContext';

const UniversityCard = ({ university, onFollow, isFollowing }) => {
  const { user } = useAuth();
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);

  const handleFollowClick = () => {
    onFollow(university?.id);
  };

  const handleAnalyzeClick = () => {
    if (!user?.id) {
      alert('Please log in to analyze your admission chances');
      return;
    }
    setShowAnalysisModal(true);
  };

  return (
    <>
      <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-md transition-all duration-200">
        <div className="p-5">
          <div className="flex items-start justify-between gap-3 mb-4">
            <div className="flex-1 min-w-0">
              <h3 className="text-xl font-bold text-foreground mb-1 truncate">
                {university?.name || 'Unknown University'}
              </h3>
            </div>
            <button
              onClick={handleFollowClick}
              className={`flex-shrink-0 p-2 rounded-full transition-all duration-200 ${
                isFollowing 
                  ? 'bg-red-500/10 text-red-500 hover:bg-red-500/20' 
                  : 'bg-muted/50 text-muted-foreground hover:bg-muted hover:text-foreground'
              }`}
              aria-label={isFollowing ? 'Unfollow university' : 'Follow university'}
            >
              <Icon name={isFollowing ? 'Heart' : 'HeartOff'} size={20} className={isFollowing ? 'fill-current' : ''} />
            </button>
          </div>

          <div className="grid grid-cols-3 gap-3 mb-4">
            <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-lg p-3 border border-primary/20">
              <div className="text-xs font-medium text-muted-foreground mb-1">Admit Rate</div>
              <div className="text-lg font-bold text-primary">
                {university?.admit_rate ? `${university.admit_rate}%` : 'Not specified'}
              </div>
            </div>
            <div className="bg-muted/30 rounded-lg p-3 border border-border/50">
              <div className="text-xs font-medium text-muted-foreground mb-1">Avg GPA</div>
              <div className="text-lg font-bold text-foreground">
                {university?.gpa || 'Not specified'}
              </div>
            </div>
            <div className="bg-muted/30 rounded-lg p-3 border border-border/50">
              <div className="text-xs font-medium text-muted-foreground mb-1">SAT Range</div>
              <div className="text-sm font-bold text-foreground">
                {university?.sat || 'Not specified'}
              </div>
            </div>
          </div>

          <button
            onClick={handleAnalyzeClick}
            className="w-full bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-primary-foreground font-semibold py-2.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-2"
          >
            <Icon name="Zap" size={18} />
            Analyse Your Chances
          </button>
        </div>
      </div>

      {showAnalysisModal && (
        <UniversityAnalysisModal
          isOpen={showAnalysisModal}
          onClose={() => setShowAnalysisModal(false)}
          userId={user?.id}
          currentUniversityId={university?.id}
          onAnalysisComplete={() => {
            setShowAnalysisModal(false);
            // Could refresh data here if needed
          }}
        />
      )}
    </>
  );
};

export default UniversityCard;